//lowercase letters, uppercase letters, numbers, and special characters: - (regular expression)
export const allowedChars = "^[a-zA-Z0-9$-]$";
export const allowedNumbers = "^[0-9]$";